import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Login.css';
import { AuthContext } from './../../ContextApi/ContextApi';
import { API_URL } from './../../api/apiurls';
import Swal from 'sweetalert2';
const formatToDDMMYYYY = (dateInput) => {
  if (!dateInput || dateInput === "null") return null;

  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return null;

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};

const LoginPage = () => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [loginStatus, setLoginStatus] = useState('');

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
// const DEFAULT_LICENSE_DATE = "2025-11-24";
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}user-detail/${username}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const json = await response.json();
      const user = json[0];

      if (!user) {
        Swal.fire({
          icon: "error",
          title: "User Not Found",
          text: "No user found with this username.",
        });
        return;
      }


  const licenseDateRaw = user.license_end_date; 
const licenseDateFormatted = formatToDDMMYYYY(licenseDateRaw);

if (licenseDateRaw) {
  const today = new Date();
  const expiry = new Date(licenseDateRaw);

  if (expiry < today) {
    Swal.fire({
      icon: "error",
      title: "License Expired",
      // show formatted date if available, otherwise fall back to raw string
      text: `Your subscription expired on ${licenseDateFormatted || licenseDateRaw}. Please renew to continue.`,
    });
    return; 
  }
}
//  const licenseDate = user.license_end_date;
//       // 🔥 CHECK LICENSE EXPIRY BEFORE PASSWORD CHECK
//       if (licenseDate) {
//         const today = new Date();
//         const expiry = new Date(licenseDate);

//         if (expiry < today) {
//           Swal.fire({
//             icon: "error",
//             title: "License Expired",
//             text: `Your subscription expired on ${licenseDate}. Please renew to continue.`,
//           });
//           return; // ❌ STOP LOGIN
//         }
//       }

      // 🔐 PASSWORD CHECK
      if (user.password === password) {
        login(user); 
        setLoginStatus('Login successful!');
        navigate('/home');
      } else {
        setLoginStatus('Login failed. Incorrect password.');
      }

    } catch (error) {
      console.error('Error fetching user details:', error);
      setLoginStatus('Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="container-fluid min-vh-100 position-relative overflow-hidden d-flex justify-content-center align-items-center bg-light">
      <div className="big-circle position-absolute z-0"></div>
      <div className="small-circle position-absolute z-0"></div>

      <div className="w-100 d-flex flex-column align-items-center z-10" style={{ marginTop: '15vh' }}>
        <div className="col-10 col-md-8 col-lg-6 bg-[#DAEAF1] rounded-3 p-4 pb-5 shadow-lg auth-box position-relative">
          <div className="w-100 bg-[#FF06B7] rounded-circle mx-auto d-flex align-items-center justify-content-center shadow-sm" style={{ width: '100px', height: '100px', position: 'relative', top: '-50px', marginBottom: '-50px' }}>
            <span className="text-dark fs-3 fw-bold">B-logic IT Solutions</span>
          </div>

          <h1 className="fs-2 fw-semibold mt-4 text-dark text-center">Login</h1>
          <hr className="w-100 h-25 bg-secondary mt-2" />

          <form onSubmit={handleLogin}>
            <div className="mt-3">
              <label className="fs-5 mb-1 fw-semibold text-dark" htmlFor="username">Username</label>
              <input
                className="form-control bg-[#F2D1D1] text-dark fw-medium fs-6 shadow-sm"
                type="text"
                id="username"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>

            <div className="mt-3">
              <label className="fs-5 mb-1 fw-semibold text-dark" htmlFor="password">Password</label>
              <input
                className="form-control bg-[#F2D1D1] text-dark fw-medium fs-6 shadow-sm"
                type="password"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary bg-[#3AB0FF] mt-4 py-2 w-100">
              <span className="text-white fs-4 fw-bold">Login</span>
            </button>
          </form>

          <p className="text-center mt-3 fs-6 text-dark fw-normal">
            {loginStatus || ''}
          </p>
          <p className="text-center mt-2 fs-6 text-dark fw-normal">
            Don't have an account? <u>Register now!</u>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
